export default {"src":"/_next/static/media/icon0.1f86a2eb.svg","height":500,"width":600,"blurWidth":0,"blurHeight":0};